import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {FusePageSimple} from '../../../../@fuse/index';
import UecareListHeader from "../../../../components/header/UecareListHeader";
import ReduxSurvey from "../../../../store/actionreducers/survey";
import SurveyList from "./SurveyLinkList";

class Survey extends Component {
    state = {
        survey: [],
    }

    async componentDidMount() {
        const {getSurvey} = this.props;
        this.setState({survey: await getSurvey()})
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='問卷統計' icon='card_membership'/>
                    }

                    content={
                        <SurveyList survey={this.state.survey} />
                    }
                    sidebarInner
                />
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: 160,
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSurvey: ReduxSurvey.ActionCreator.getSurvey,
    }, dispatch);
}

function mapStateToProps({mission: {list}}) {
    return {
        missions: list,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(Survey)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/survey/Survey.js